import ServiceBase from "base/baseService"
import { numberToBool, toJSDate } from "helper/formater"
import server from "infra/server"

export default class TributoService extends ServiceBase {

    title = "Tributo"
    pluralTitle = "Tributos"
    url = '/cadastro/fiscal/tributo'
    frontUrl = '/cadastro/fiscal/tributo'
    frontUrlList = '/cadastro/fiscal/tributolist'
    primaryKey = 'codigo_tri'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Flags
        data.ativo_tri = numberToBool(data.ativo_tri)
        data.serv_tri = numberToBool(data.serv_tri)
        data.merc_tri = numberToBool(data.merc_tri)

        // Strings notNullable
        data.descricao_tri = data?.descricao_tri || ''
        data.sigla_tri = data?.sigla_tri || ''
        data.obs_tri = data?.obs_tri || ''
        data.cods_tiof_tri = data?.cods_tiof_tri || ''
        data.campos_opefis_tri = data?.campos_opefis_tri || ''
        data.cod_esf_tri = data?.cod_esf_tri || ''

        // FK numéricas
        data.cod_tiptri_tri = data?.cod_tiptri_tri ?? null
        data.cod_tabcst_tri = data?.cod_tabcst_tri ?? null

        // Datas
        data.ini_vig_tri = toJSDate(data.ini_vig_tri)
        data.fim_vig_tri = toJSDate(data.fim_vig_tri)

        return data
    }

    prepareToSave({ data }) {
        if ('meta' in data) delete data.meta
        return data
    }

    async listTipoTributos() {
        return server().get('/cadastro/fiscal/tipotributo')
    }

}
